export default __webpack_public_path__ + "static/media/2.4aa546d4.jpeg";